import React from "react";
import styles from "./listing.module.css";

const Header = () => {
  return (
    <>
      <div className={styles.listHeader}>
        <h1>My listings</h1>
      </div>
    </>
  );
};

export default Header;
